import React from 'react';
import { useFieldArray } from 'react-hook-form';
import { X, Plus } from 'lucide-react';

export const ArrayField = ({ field, control, register, errors, theme, renderField }) => {
  const { fields: arrayFields, append, remove } = useFieldArray({
    control,
    name: field.id
  });
  
  return (
    <div className="space-y-2">
      {arrayFields.map((item, index) => (
        <div key={item.id} className="flex space-x-2">
          <div className="flex-1">
            {renderField({
              ...field.itemField,
              id: `${field.id}.${index}.value`,
              validation: field.itemField?.validation
            }, `${field.id}.${index}`)}
          </div>
          <button
            type="button"
            onClick={() => remove(index)}
            className="text-red-500 hover:text-red-700"
          >
            <X size={20} />
          </button>
        </div>
      ))}
      
      <button
        type="button"
        onClick={() => append({ value: '' })}
        className={`${theme.secondaryButton} flex items-center space-x-2`}
      >
        <Plus size={16} />
        <span>Add {field.itemLabel || 'Item'}</span>
      </button>
    </div>
  );
};